import { Eye } from 'lucide-react';

const STATUTS = {
  signe: ['Signé', 'bg-emerald-100 text-emerald-700'],
  a_signer: ['À signer', 'bg-amber-100 text-amber-700'],
  non_envoye: ['Non envoyé', 'bg-slate-100 text-slate-500'],
};
const dateFr = (iso) => new Date(iso).toLocaleDateString('fr-FR');

export const LigneReglement = ({ s, coche, onCocher, onVoir, selection }) => {
  const [label, cls] = STATUTS[s.statut];
  const nom = `${s.prenom} ${s.nom}`.trim();
  return (
    <li className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`reglement-ligne-${s.user_id}`}>
      {selection && <input type="checkbox" checked={coche} disabled={s.statut === 'signe'} onChange={onCocher} className="h-4 w-4 accent-orange-500 disabled:opacity-30"
        aria-label={`Sélectionner ${nom}`} data-testid={`reglement-case-${s.user_id}`} />}
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-[#0F172A]">{nom || 'Stagiaire'} <span className="font-normal text-slate-400">· {s.session ? `Session ${s.session}` : 'Sans session'}</span></p>
        <p className="text-xs text-slate-500">
          {s.envoye_le ? `Envoyé le ${dateFr(s.envoye_le)}${s.nb_envois > 1 ? ` (${s.nb_envois} envois)` : ''}` : 'Pas encore envoyé'}
          {s.nb_relances > 0 && !s.signe_le && ` · Relancé le ${dateFr(s.derniere_relance)} (${s.nb_relances} relance${s.nb_relances > 1 ? 's' : ''})`}
          {s.signe_le && ` · Signé le ${dateFr(s.signe_le)}`}{!s.email && ' · sans e-mail'}
        </p>
      </div>
      <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls}`} data-testid={`reglement-statut-${s.user_id}`}>{label}</span>
      {s.statut === 'signe' && (
        <button type="button" onClick={() => onVoir(s)} data-testid={`reglement-voir-${s.user_id}`}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs font-semibold text-slate-700 transition-colors hover:bg-slate-50">
          <Eye className="h-3.5 w-3.5" /> Voir signé
        </button>
      )}
    </li>
  );
};
